import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Icon,
  Checkbox,
  Dropdown
} from 'semantic-ui-react'

const CardOrderSummaryUX = (props: any) => {
    return(
      <div>
        <div
          id="CardOrderSummaryUX-div-1"
          style={{fontSize: "1.5rem", fontWeight: "bold", padding: "5px"}}>
          {props.languageUX === "en" ? "Medical order List" : "รายการคำสั่งแพทย์"}
        </div>
        <div
          id="CardOrderSummaryUX-div-2"
          style={{padding: "5px", display: "flex", justifyContent: "center",alignItems: "center"}}>
          
          <div
            id="CardOrderSummaryUX-div-13"
            style={{padding: "5px"}}>
            
            <Icon
              id="CardOrderSummaryUX-Icon-14"
              name={"angle double left"}
              onClick={props.onChangeStepDate}>
            </Icon>
          </div>
          <DateTextBox
            id="CardOrderSummaryUX-DateTextBox-10"
            onChange={props.onChangeDate}
            value={props.date}>
          </DateTextBox>
          <div
            id="CardOrderSummaryUX-div-12"
            style={{padding: "5px"}}>
            
            <Icon
              id="CardOrderSummaryUX-Icon-11"
              name={"angle double right"}
              onClick={props.onChangeStepDate}>
            </Icon>
          </div>
        </div>
        <div
          id="CardOrderSummaryUX-div-3"
          style={{padding: "5px", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          
          <Checkbox
            checked={props.filterOrderSummary.isNurseStatus}
            id="CardOrderSummaryUX-Checkbox-15"
            name="isNurseStatus"
            onChange={props.onChangeFilter}>
          </Checkbox>
          <div
            id="CardOrderSummaryUX-div-42"
            style={{margin: "0 5px 0 5px", minWidth: "max-content"}}>
            {props.languageUX === "en" ? "Order status" : "สถานะคำสั่ง"}
          </div>
          <Dropdown
            id="CardOrderSummaryUX-Dropdown-16"
            name="nurseStatus"
            onChange={props.onChangeFilter}
            options={[{ 'key': 'wait', 'text': 'รอรับคำสั่ง', value: 'wait' }, { 'key': 'know', 'text': 'รับทราบแล้ว', value: 'know' }, { 'key': 'cancel', 'text': 'ยกเลิก', value: 'cancel' }]}
            selection={true}
            value={props.filterOrderSummary.nurseStatus}>
          </Dropdown>
          <div
            id="CardOrderSummaryUX-div-49"
            style={{paddingLeft: "10px", minWidth: "max-content"}}>
            
            <div
              id="CardOrderSummaryUX-div-52">
              {props.medInfoButton}
            </div>
          </div>
          <div
            id="CardOrderSummaryUX-div-17"
            style={{flex: 1, paddingRight: "2rem"}}>
            
          </div>
          <div
            id="CardOrderSummaryUX-div-18"
            style={{display: "flex", alignItems: "center",minWidth: "max-content"}}>
            
            <Checkbox
              checked={props.filterOrderSummary.isOutPerformDivision}
              id="CardOrderSummaryUX-Checkbox-19"
              name="isOutPerformDivision"
              onChange={props.onChangeFilter}>
            </Checkbox>
            <label
              id="CardOrderSummaryUX-label-20"
              style={{margin: "0 10px 0 10px"}}>
              {props.languageUX === "en" ? "Extra-departmental orders" : "คำสั่งนอกแผนก"}
            </label>
          </div>
          <div
            id="CardOrderSummaryUX-div-21"
            style={{display: "flex", alignItems: "center",minWidth: "max-content"}}>
            
            <Checkbox
              checked={props.filterOrderSummary.isPharmacy}
              id="CardOrderSummaryUX-Checkbox-22"
              name="isPharmacy"
              onChange={props.onChangeFilter}>
            </Checkbox>
            <label
              id="CardOrderSummaryUX-label-23"
              style={{margin: "0 10px 0 10px"}}>
              {props.languageUX === "en" ? "Pharmacy" : "ยา"}
            </label>
          </div>
          <div
            id="CardOrderSummaryUX-div-24"
            style={{display: "flex", alignItems: "center",minWidth: "max-content"}}>
            
            <Checkbox
              checked={props.filterOrderSummary.isTreatmentOrder}
              id="CardOrderSummaryUX-Checkbox-25"
              name="isTreatmentOrder"
              onChange={props.onChangeFilter}>
            </Checkbox>
            <label
              id="CardOrderSummaryUX-label-26"
              style={{margin: "0 10px 0 10px"}}>
              {props.languageUX === "en" ? "Treatment" : "การรักษา"}
            </label>
          </div>
          <div
            id="CardOrderSummaryUX-div-27"
            style={{display: "flex", alignItems: "center",minWidth: "max-content"}}>
            
            <Checkbox
              checked={props.filterOrderSummary.isLab}
              id="CardOrderSummaryUX-Checkbox-28"
              name="isLab"
              onChange={props.onChangeFilter}>
            </Checkbox>
            <label
              id="CardOrderSummaryUX-label-29"
              style={{margin: "0 10px 0 10px"}}>
              {props.languageUX === "en" ? "Lab" : "แล็บ"}
            </label>
          </div>
          <div
            id="CardOrderSummaryUX-div-30"
            style={{display: "flex", alignItems: "center",minWidth: "max-content"}}>
            
            <Checkbox
              checked={props.filterOrderSummary.isFood}
              id="CardOrderSummaryUX-Checkbox-31"
              name="isFood"
              onChange={props.onChangeFilter}>
            </Checkbox>
            <label
              id="CardOrderSummaryUX-label-32"
              style={{margin: "0 10px 0 10px"}}>
              {props.languageUX === "en" ? "Food" : "อาหาร"}
            </label>
          </div>
          <div
            id="CardOrderSummaryUX-div-33"
            style={{display: "flex", alignItems: "center",minWidth: "max-content"}}>
            
            <Checkbox
              checked={props.filterOrderSummary.isNoteOrder}
              id="CardOrderSummaryUX-Checkbox-34"
              name="isNoteOrder"
              onChange={props.onChangeFilter}>
            </Checkbox>
            <label
              id="CardOrderSummaryUX-label-35"
              style={{margin: "0 10px 0 10px"}}>
              {props.languageUX === "en" ? "Note Order" : "คำสั่งอื่นๆ "}
            </label>
          </div>
          <div
            id="CardOrderSummaryUX-div-36"
            style={{display: "flex", alignItems: "center",minWidth: "max-content"}}>
            
            <Checkbox
              checked={props.filterOrderSummary.isProcedure}
              id="CardOrderSummaryUX-Checkbox-37"
              name="isProcedure"
              onChange={props.onChangeFilter}>
            </Checkbox>
            <label
              id="CardOrderSummaryUX-label-38"
              style={{margin: "0 10px 0 10px"}}>
              {props.languageUX === "en" ? "Procedure" : "หัตถการ"}
            </label>
          </div>
          <div
            id="CardOrderSummaryUX-div-39"
            style={{display: "flex", alignItems: "center",minWidth: "max-content"}}>
            
            <Checkbox
              checked={props.filterOrderSummary.isHD}
              id="CardOrderSummaryUX-Checkbox-40"
              name="isHD"
              onChange={props.onChangeFilter}>
            </Checkbox>
            <label
              id="CardOrderSummaryUX-label-41"
              style={{margin: "0 10px 0 10px"}}>
              {props.languageUX === "en" ? "HD" : "การฟอกเลือด"}
            </label>
          </div>
          <div
            id="CardOrderSummaryUX-div-46"
            style={{display: "flex", alignItems: "center",minWidth: "max-content"}}>
            
            <Checkbox
              checked={props.filterOrderSummary.isImaging}
              id="CardOrderSummaryUX-Checkbox-47"
              name="isImaging"
              onChange={props.onChangeFilter}>
            </Checkbox>
            <label
              id="CardOrderSummaryUX-label-48"
              style={{margin: "0 10px 0 10px"}}>
              {props.languageUX === "en" ? "Imaging" : "ภาพถ่ายทางรังสี"}
            </label>
          </div>
        </div>
        <div
          id="CardOrderSummaryUX-div-4"
          style={{display: "flex"}}>
          
          <div
            id="CardOrderSummaryUX-div-5"
            style={{flex:1, padding: "5px" }}>
            
            <div
              id="CardOrderSummaryUX-div-43"
              style={{fontSize: "1.2rem", fontWeight: "bold", padding: "5px"}}>
              {props.languageUX === "en" ? "One Day" : "คำสั่งในวัน"}
            </div>
            <Table
              data={props.orderSummaryOneDayItems}
              headers={props.isDoctor? "Order,รายการคำสั่งแพทย์,รับคำสั่ง,Menu": ",Order,รายการคำสั่งแพทย์,รับคำสั่ง,Menu"}
              id="CardOrderSummaryUX-Table-7"
              keys={props.isDoctor? "type_name,summary,nurse_status, menu":"_check,type_name,summary,nurse_status, menu"}
              minRows="8"
              showPagination={false}
              style={{height: props.isDoctor?"calc(100dvh - 18rem)":"calc(100dvh - 22rem)"}}
              widths={props.isDoctor? "^125,^275,^80,^60": "^35,^125,^250,^80,^60"}>
            </Table>
          </div>
          <div
            id="CardOrderSummaryUX-div-6"
            style={{flex:1, padding: "5px" }}>
            
            <div
              id="CardOrderSummaryUX-div-44"
              style={{fontSize: "1.2rem", fontWeight: "bold", padding: "5px"}}>
              {props.languageUX === "en" ? "Continue" : "คำสั่งต่อเนื่อง"}
            </div>
            <Table
              data={props.orderSummaryItems}
              headers={props.isDoctor? "Order,รายการคำสั่งแพทย์,รับคำสั่ง,Menu":",Order,รายการคำสั่งแพทย์,รับคำสั่ง,Menu"}
              id="CardOrderSummaryUX-Table-9"
              keys={props.isDoctor? "type_name,summary,nurse_status, menu": "_check,type_name,summary,nurse_status, menu"}
              minRows="8"
              showPagination={false}
              style={{height: props.isDoctor?"calc(100dvh - 18rem)":"calc(100dvh - 22rem)"}}
              widths={props.isDoctor? "^125,^275,^80,^60" : "^35,^125,^250,^80,^60"}>
            </Table>
          </div>
        </div>
        <div
          id="CardOrderSummaryUX-div-45"
          style={{padding: "5px", display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
          {props.orderPerformAction}
        </div>
      </div>
    )
}


export default CardOrderSummaryUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Thu Nov 20 2025 07:17:10 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการคำสั่งแพทย์",
          "valueEN": "Medical order List"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.5rem\", fontWeight: \"bold\", padding: \"5px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px\", display: \"flex\", justifyContent: \"center\",alignItems: \"center\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px\", display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{flex:1, padding: \"5px\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{flex:1, padding: \"5px\" }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 7,
      "name": "Table",
      "parent": 5,
      "props": {
        "data": {
          "type": "code",
          "value": "props.orderSummaryOneDayItems"
        },
        "headers": {
          "type": "code",
          "value": "props.isDoctor? \"Order,รายการคำสั่งแพทย์,รับคำสั่ง,Menu\": \",Order,รายการคำสั่งแพทย์,รับคำสั่ง,Menu\""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-Table-7"
        },
        "keys": {
          "type": "code",
          "value": "props.isDoctor? \"type_name,summary,nurse_status, menu\":\"_check,type_name,summary,nurse_status, menu\""
        },
        "minRows": {
          "type": "value",
          "value": "8"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: props.isDoctor?\"calc(100dvh - 18rem)\":\"calc(100dvh - 22rem)\"}"
        },
        "widths": {
          "type": "code",
          "value": "props.isDoctor? \"^125,^275,^80,^60\": \"^35,^125,^250,^80,^60\""
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 9,
      "name": "Table",
      "parent": 6,
      "props": {
        "data": {
          "type": "code",
          "value": "props.orderSummaryItems"
        },
        "headers": {
          "type": "code",
          "value": "props.isDoctor? \"Order,รายการคำสั่งแพทย์,รับคำสั่ง,Menu\":\",Order,รายการคำสั่งแพทย์,รับคำสั่ง,Menu\""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-Table-9"
        },
        "keys": {
          "type": "code",
          "value": "props.isDoctor? \"type_name,summary,nurse_status, menu\": \"_check,type_name,summary,nurse_status, menu\""
        },
        "minRows": {
          "type": "value",
          "value": "8"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: props.isDoctor?\"calc(100dvh - 18rem)\":\"calc(100dvh - 22rem)\"}"
        },
        "widths": {
          "type": "code",
          "value": "props.isDoctor? \"^125,^275,^80,^60\" : \"^35,^125,^250,^80,^60\""
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 10,
      "name": "DateTextBox",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-DateTextBox-10"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate"
        },
        "value": {
          "type": "code",
          "value": "props.date"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Icon",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-Icon-11"
        },
        "name": {
          "type": "code",
          "value": "\"angle double right\""
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeStepDate"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Icon",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-Icon-14"
        },
        "name": {
          "type": "code",
          "value": "\"angle double left\""
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeStepDate"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Checkbox",
      "parent": 3,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterOrderSummary.isNurseStatus"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-Checkbox-15"
        },
        "name": {
          "type": "value",
          "value": "isNurseStatus"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "Dropdown",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-Dropdown-16"
        },
        "name": {
          "type": "value",
          "value": "nurseStatus"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "[{ 'key': 'wait', 'text': 'รอรับคำสั่ง', value: 'wait' }, { 'key': 'know', 'text': 'รับทราบแล้ว', value: 'know' }, { 'key': 'cancel', 'text': 'ยกเลิก', value: 'cancel' }]"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.filterOrderSummary.nurseStatus"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1, paddingRight: \"2rem\"}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",minWidth: \"max-content\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "Checkbox",
      "parent": 18,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterOrderSummary.isOutPerformDivision"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-Checkbox-19"
        },
        "name": {
          "type": "value",
          "value": "isOutPerformDivision"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "label",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "คำสั่งนอกแผนก",
          "valueEN": "Extra-departmental orders"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-label-20"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 10px 0 10px\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",minWidth: \"max-content\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Checkbox",
      "parent": 21,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterOrderSummary.isPharmacy"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-Checkbox-22"
        },
        "name": {
          "type": "value",
          "value": "isPharmacy"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "label",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": "ยา",
          "valueEN": "Pharmacy"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-label-23"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 10px 0 10px\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",minWidth: \"max-content\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Checkbox",
      "parent": 24,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterOrderSummary.isTreatmentOrder"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-Checkbox-25"
        },
        "name": {
          "type": "value",
          "value": "isTreatmentOrder"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "label",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": "การรักษา",
          "valueEN": "Treatment"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-label-26"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 10px 0 10px\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",minWidth: \"max-content\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Checkbox",
      "parent": 27,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterOrderSummary.isLab"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-Checkbox-28"
        },
        "name": {
          "type": "value",
          "value": "isLab"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "label",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "แล็บ",
          "valueEN": "Lab"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-label-29"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 10px 0 10px\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-30"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",minWidth: \"max-content\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "Checkbox",
      "parent": 30,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterOrderSummary.isFood"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-Checkbox-31"
        },
        "name": {
          "type": "value",
          "value": "isFood"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "label",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "อาหาร",
          "valueEN": "Food"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-label-32"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 10px 0 10px\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-33"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",minWidth: \"max-content\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Checkbox",
      "parent": 33,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterOrderSummary.isNoteOrder"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-Checkbox-34"
        },
        "name": {
          "type": "value",
          "value": "isNoteOrder"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "label",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": "คำสั่งอื่นๆ ",
          "valueEN": "Note Order"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-label-35"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 10px 0 10px\"}"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-36"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",minWidth: \"max-content\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Checkbox",
      "parent": 36,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterOrderSummary.isProcedure"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-Checkbox-37"
        },
        "name": {
          "type": "value",
          "value": "isProcedure"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "label",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": "หัตถการ",
          "valueEN": "Procedure"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-label-38"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 10px 0 10px\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",minWidth: \"max-content\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "Checkbox",
      "parent": 39,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterOrderSummary.isHD"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-Checkbox-40"
        },
        "name": {
          "type": "value",
          "value": "isHD"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "label",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": "การฟอกเลือด",
          "valueEN": "HD"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-label-41"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 10px 0 10px\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะคำสั่ง",
          "valueEN": "Order status"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 5px 0 5px\", minWidth: \"max-content\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "คำสั่งในวัน",
          "valueEN": "One Day"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.2rem\", fontWeight: \"bold\", padding: \"5px\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "คำสั่งต่อเนื่อง",
          "valueEN": "Continue"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-44"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.2rem\", fontWeight: \"bold\", padding: \"5px\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.orderPerformAction"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-45"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\"}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-46"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",minWidth: \"max-content\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "Checkbox",
      "parent": 46,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterOrderSummary.isImaging"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-Checkbox-47"
        },
        "name": {
          "type": "value",
          "value": "isImaging"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "label",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": "ภาพถ่ายทางรังสี",
          "valueEN": "Imaging"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-label-48"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 10px 0 10px\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"10px\", minWidth: \"max-content\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 49,
      "props": {
        "children": {
          "type": "code",
          "value": "props.medInfoButton"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSummaryUX-div-52"
        }
      },
      "seq": 52,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardOrderSummaryUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 75
}

*********************************************************************************** */
